import settings from './settings'

export function isOnStudioDomain() {
    return window.location.host === settings.STUDIO_DOMAIN
}
